// @ts-nocheck
import { QueryObject, QGuidPath, QBooleanPath, QDateTimeOffsetPath, QStringPath, QNumberPath, QEnumPath, QEntityCollectionPath, QId, QGuidParam, QEntityPath, QCollectionPath, QStringCollection, QGuidCollection, QFunction, OperationReturnType, ReturnTypes, QComplexParam, QAction } from "@odata2ts/odata-query-objects";
import type { LogMessageCatalogId, LogMessageCatalogParametersId, LogMessageCatalogLanguagesId, FileId, FolderId, SegregationTagId, NumberingPatternId, EquipmentId, TaskContextUserFieldId, TaskContextId, TaskContextDefinitionUserFieldId, TaskContextDefinitionId, UoMDimensionId, UoMId, WorkflowGatewayId, TaskParameterId, TaskId, TaskTypeId, TaskDefinitionParameterId, TaskDefinitionId, StateMachineId, StatusId, NumberingPatternFacetId, EquipmentFacetId, TaskContextUserFieldFacetId, TaskContextFacetId, TaskContextDefinitionUserFieldFacetId, TaskContextDefinitionFacetId, UoMDimensionFacetId, UoMFacetId, WorkflowGatewayFacetId, TaskParameterFacetId, TaskFacetId, TaskTypeFacetId, TaskDefinitionParameterFacetId, TaskDefinitionFacetId, StateMachineFacetId, StatusFacetId, GetTasksForTaskList2Params, GetAllTasks2Params, CreateTaskDefinition2Params, UpdateTaskDefinition2Params, DeleteTaskDefinition2Params, UpdateTaskDefinitionParameter2Params, DeleteTaskDefinitionParameter2Params, LockTaskDefinition2Params, UnlockTaskDefinition2Params, SetTaskDefinitionRevisionCurrent2Params, UnsetTaskDefinitionRevisionCurrent2Params, CopyTaskDefinitionRevision2Params, CreateNewTaskDefinitionRevision2Params, AssociateTaskContextDefinitionsWithTaskDefinition2Params, DisassociateTaskContextDefinitionsFromTaskDefinition2Params, CreateTaskContextDefinition2Params, UpdateTaskContextDefinition2Params, DeleteTaskContextDefinition2Params, UpdateTaskContextDefinitionUserField2Params, DeleteTaskContextDefinitionUserField2Params, CreateTask2Params, UpdateTask2Params, DeleteTask2Params, UpdateTaskParameter2Params, SetTaskStatus2Params, ForceTaskStatus2Params, ActivateTask2Params, SuspendTask2Params, StartTask2Params, PauseTask2Params, ResumeTask2Params, RecoverTask2Params, FailTask2Params, CompleteTask2Params, AbortTask2Params, CancelTask2Params, SkipTask2Params, FreezeTask2Params, UnfreezeTask2Params, SetErrorCount2Params, ChangeTaskStatusOnAction2Params, RepeatTask2Params, ActivateSequenceStep2Params, CheckSequenceStepCompleted2Params, RemoveTaskFromTaskFlow2Params, DeleteTasks2Params, ActivateTasks2Params, AbortTasks2Params, CancelTasks2Params, CompleteTasks2Params, SkipTasks2Params, SuspendTasks2Params, PauseTasks2Params, DeleteTaskDefinitions2Params, DeleteTaskContextDefinitions2Params } from "./TaskModel";
import { ApplicationLogLevelType, SegregationTagStatus, SupportedTypes, TaskDefinitionParameterDirections, StatusesOutcome } from "./TaskModel";

export class QLogMessageCatalog extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Owner = new QStringPath(this.withPrefix("Owner"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly MessageId = new QNumberPath(this.withPrefix("MessageId"));
    public readonly Level = new QEnumPath(this.withPrefix("Level"), ApplicationLogLevelType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalogParameters = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogParameters"), () => QLogMessageCatalogParameters);
    public readonly LogMessageCatalogLanguages = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogLanguages"), () => QLogMessageCatalogLanguages);
}

export const qLogMessageCatalog = new QLogMessageCatalog();

export class QLogMessageCatalogId extends QId<LogMessageCatalogId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogParameters extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterKey = new QStringPath(this.withPrefix("ParameterKey"));
    public readonly ParameterType = new QStringPath(this.withPrefix("ParameterType"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogParameters = new QLogMessageCatalogParameters();

export class QLogMessageCatalogParametersId extends QId<LogMessageCatalogParametersId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogLanguages extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogLanguages = new QLogMessageCatalogLanguages();

export class QLogMessageCatalogLanguagesId extends QId<LogMessageCatalogLanguagesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly PayloadSize = new QNumberPath(this.withPrefix("PayloadSize"));
    public readonly CreatedBy = new QStringPath(this.withPrefix("CreatedBy"));
    public readonly LastUpdatedBy = new QStringPath(this.withPrefix("LastUpdatedBy"));
    public readonly Folder_Id = new QGuidPath(this.withPrefix("Folder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Folder = new QEntityPath(this.withPrefix("Folder"), () => QFolder);
}

export const qFile = new QFile();

export class QFileId extends QId<FileId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFolder extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ParentFolder_Id = new QGuidPath(this.withPrefix("ParentFolder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentFolder = new QEntityPath(this.withPrefix("ParentFolder"), () => QFolder);
}

export const qFolder = new QFolder();

export class QFolderId extends QId<FolderId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSegregationTag extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly TagStatus = new QEnumPath(this.withPrefix("TagStatus"), SegregationTagStatus);
    public readonly IsLogRelevant = new QBooleanPath(this.withPrefix("IsLogRelevant"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
}

export const qSegregationTag = new QSegregationTag();

export class QSegregationTagId extends QId<SegregationTagId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPattern extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EntityTypeNId = new QStringPath(this.withPrefix("EntityTypeNId"));
    public readonly DestinationProperty = new QStringPath(this.withPrefix("DestinationProperty"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternFacet);
}

export const qNumberingPattern = new QNumberingPattern();

export class QNumberingPatternId extends QId<NumberingPatternId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipment extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly WorkCalendarNId = new QStringPath(this.withPrefix("WorkCalendarNId"));
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentFacet);
}

export const qEquipment = new QEquipment();

export class QEquipmentId extends QId<EquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
    public readonly TaskContext_Id = new QGuidPath(this.withPrefix("TaskContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContext = new QEntityPath(this.withPrefix("TaskContext"), () => QTaskContext);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextUserFieldFacet);
}

export const qTaskContextUserField = new QTaskContextUserField();

export class QTaskContextUserFieldId extends QId<TaskContextUserFieldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContext extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContextEntityType = new QStringPath(this.withPrefix("ContextEntityType"));
    public readonly ContextDefinitionNId = new QStringPath(this.withPrefix("ContextDefinitionNId"));
    public readonly Task_Id = new QGuidPath(this.withPrefix("Task_Id"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QTaskContextUserField);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Task = new QEntityPath(this.withPrefix("Task"), () => QTask);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextFacet);
}

export const qTaskContext = new QTaskContext();

export class QTaskContextId extends QId<TaskContextId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinitionUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
    public readonly TaskContextDefinition_Id = new QGuidPath(this.withPrefix("TaskContextDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinition = new QEntityPath(this.withPrefix("TaskContextDefinition"), () => QTaskContextDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextDefinitionUserFieldFacet);
}

export const qTaskContextDefinitionUserField = new QTaskContextDefinitionUserField();

export class QTaskContextDefinitionUserFieldId extends QId<TaskContextDefinitionUserFieldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContextEntityType = new QStringPath(this.withPrefix("ContextEntityType"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QTaskContextDefinitionUserField);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskDefinitions = new QEntityCollectionPath(this.withPrefix("TaskDefinitions"), () => QTaskDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextDefinitionFacet);
}

export const qTaskContextDefinition = new QTaskContextDefinition();

export class QTaskContextDefinitionId extends QId<TaskContextDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMDimension extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMs = new QEntityCollectionPath(this.withPrefix("UoMs"), () => QUoM);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUoMDimensionFacet);
}

export const qUoMDimension = new QUoMDimension();

export class QUoMDimensionId extends QId<UoMDimensionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoM extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly UoMDimension_Id = new QGuidPath(this.withPrefix("UoMDimension_Id"));
    public readonly UoMBase_Id = new QGuidPath(this.withPrefix("UoMBase_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMDimension = new QEntityPath(this.withPrefix("UoMDimension"), () => QUoMDimension);
    public readonly UoMBase = new QEntityPath(this.withPrefix("UoMBase"), () => QUoM);
    public readonly UoMsMultipleOrSubmultiple = new QEntityCollectionPath(this.withPrefix("UoMsMultipleOrSubmultiple"), () => QUoM);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUoMFacet);
}

export const qUoM = new QUoM();

export class QUoMId extends QId<UoMId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkflowGateway extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ContinueCount = new QNumberPath(this.withPrefix("ContinueCount"));
    public readonly BlockCount = new QNumberPath(this.withPrefix("BlockCount"));
    public readonly SiblingCount = new QNumberPath(this.withPrefix("SiblingCount"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkflowGatewayFacet);
}

export const qWorkflowGateway = new QWorkflowGateway();

export class QWorkflowGatewayId extends QId<WorkflowGatewayId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), TaskDefinitionParameterDirections);
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly Task_Id = new QGuidPath(this.withPrefix("Task_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Task = new QEntityPath(this.withPrefix("Task"), () => QTask);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskParameterFacet);
}

export const qTaskParameter = new QTaskParameter();

export class QTaskParameterId extends QId<TaskParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskMessageUI = new QStringPath(this.withPrefix("TaskMessageUI"));
    public readonly TaskDefinitionNId = new QStringPath(this.withPrefix("TaskDefinitionNId"));
    public readonly TaskDefinitionRevision = new QStringPath(this.withPrefix("TaskDefinitionRevision"));
    public readonly TaskInstanceUI = new QStringPath(this.withPrefix("TaskInstanceUI"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ErrorCount = new QNumberPath(this.withPrefix("ErrorCount"));
    public readonly IsSkippable = new QBooleanPath(this.withPrefix("IsSkippable"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly TaskFlow = new QEntityPath(this.withPrefix("TaskFlow"), () => QTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types);
    public readonly Contexts = new QEntityCollectionPath(this.withPrefix("Contexts"), () => QTaskContext);
    public readonly TaskParameters = new QEntityCollectionPath(this.withPrefix("TaskParameters"), () => QTaskParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskFacet);
}

export const qTask = new QTask();

export class QTaskId extends QId<TaskId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskDefinitionUI = new QStringPath(this.withPrefix("TaskDefinitionUI"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly TaskMessageUI = new QStringPath(this.withPrefix("TaskMessageUI"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskEntityType = new QStringPath(this.withPrefix("TaskEntityType"));
    public readonly TaskInstanceUI = new QStringPath(this.withPrefix("TaskInstanceUI"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskTypeFacet);
}

export const qTaskType = new QTaskType();

export class QTaskTypeId extends QId<TaskTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), TaskDefinitionParameterDirections);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly TaskDefinition_Id = new QGuidPath(this.withPrefix("TaskDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskDefinition = new QEntityPath(this.withPrefix("TaskDefinition"), () => QTaskDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskDefinitionParameterFacet);
}

export const qTaskDefinitionParameter = new QTaskDefinitionParameter();

export class QTaskDefinitionParameterId extends QId<TaskDefinitionParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskDefinitionUI = new QStringPath(this.withPrefix("TaskDefinitionUI"));
    public readonly TaskMessageUI = new QStringPath(this.withPrefix("TaskMessageUI"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskEntityType = new QStringPath(this.withPrefix("TaskEntityType"));
    public readonly TaskInstanceUI = new QStringPath(this.withPrefix("TaskInstanceUI"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly TaskDefinitionParameters = new QEntityCollectionPath(this.withPrefix("TaskDefinitionParameters"), () => QTaskDefinitionParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinitions = new QEntityCollectionPath(this.withPrefix("TaskContextDefinitions"), () => QTaskContextDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskDefinitionFacet);
}

export const qTaskDefinition = new QTaskDefinition();

export class QTaskDefinitionId extends QId<TaskDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Statuses = new QEntityCollectionPath(this.withPrefix("Statuses"), () => QStatus);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStateMachineFacet);
}

export const qStateMachine = new QStateMachine();

export class QStateMachineId extends QId<StateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly IsInitial = new QBooleanPath(this.withPrefix("IsInitial"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
    public readonly StateMachine_Id = new QGuidPath(this.withPrefix("StateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StateMachine = new QEntityPath(this.withPrefix("StateMachine"), () => QStateMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusFacet);
}

export const qStatus = new QStatus();

export class QStatusId extends QId<StatusId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPattern_Id = new QGuidPath(this.withPrefix("NumberingPattern_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPattern = new QEntityPath(this.withPrefix("NumberingPattern"), () => QNumberingPattern);
}

export const qNumberingPatternFacet = new QNumberingPatternFacet();

export class QNumberingPatternFacetId extends QId<NumberingPatternFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
}

export const qEquipmentFacet = new QEquipmentFacet();

export class QEquipmentFacetId extends QId<EquipmentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextUserFieldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContextUserField_Id = new QGuidPath(this.withPrefix("TaskContextUserField_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextUserField = new QEntityPath(this.withPrefix("TaskContextUserField"), () => QTaskContextUserField);
}

export const qTaskContextUserFieldFacet = new QTaskContextUserFieldFacet();

export class QTaskContextUserFieldFacetId extends QId<TaskContextUserFieldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContext_Id = new QGuidPath(this.withPrefix("TaskContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContext = new QEntityPath(this.withPrefix("TaskContext"), () => QTaskContext);
}

export const qTaskContextFacet = new QTaskContextFacet();

export class QTaskContextFacetId extends QId<TaskContextFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinitionUserFieldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContextDefinitionUserField_Id = new QGuidPath(this.withPrefix("TaskContextDefinitionUserField_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinitionUserField = new QEntityPath(this.withPrefix("TaskContextDefinitionUserField"), () => QTaskContextDefinitionUserField);
}

export const qTaskContextDefinitionUserFieldFacet = new QTaskContextDefinitionUserFieldFacet();

export class QTaskContextDefinitionUserFieldFacetId extends QId<TaskContextDefinitionUserFieldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContextDefinition_Id = new QGuidPath(this.withPrefix("TaskContextDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinition = new QEntityPath(this.withPrefix("TaskContextDefinition"), () => QTaskContextDefinition);
}

export const qTaskContextDefinitionFacet = new QTaskContextDefinitionFacet();

export class QTaskContextDefinitionFacetId extends QId<TaskContextDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMDimensionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UoMDimension_Id = new QGuidPath(this.withPrefix("UoMDimension_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMDimension = new QEntityPath(this.withPrefix("UoMDimension"), () => QUoMDimension);
}

export const qUoMDimensionFacet = new QUoMDimensionFacet();

export class QUoMDimensionFacetId extends QId<UoMDimensionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UoM_Id = new QGuidPath(this.withPrefix("UoM_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoM = new QEntityPath(this.withPrefix("UoM"), () => QUoM);
}

export const qUoMFacet = new QUoMFacet();

export class QUoMFacetId extends QId<UoMFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkflowGatewayFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkflowGateway_Id = new QGuidPath(this.withPrefix("WorkflowGateway_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkflowGateway = new QEntityPath(this.withPrefix("WorkflowGateway"), () => QWorkflowGateway);
}

export const qWorkflowGatewayFacet = new QWorkflowGatewayFacet();

export class QWorkflowGatewayFacetId extends QId<WorkflowGatewayFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskParameter_Id = new QGuidPath(this.withPrefix("TaskParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskParameter = new QEntityPath(this.withPrefix("TaskParameter"), () => QTaskParameter);
}

export const qTaskParameterFacet = new QTaskParameterFacet();

export class QTaskParameterFacetId extends QId<TaskParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Task_Id = new QGuidPath(this.withPrefix("Task_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Task = new QEntityPath(this.withPrefix("Task"), () => QTask);
}

export const qTaskFacet = new QTaskFacet();

export class QTaskFacetId extends QId<TaskFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskType_Id = new QGuidPath(this.withPrefix("TaskType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskType = new QEntityPath(this.withPrefix("TaskType"), () => QTaskType);
}

export const qTaskTypeFacet = new QTaskTypeFacet();

export class QTaskTypeFacetId extends QId<TaskTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskDefinitionParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskDefinitionParameter_Id = new QGuidPath(this.withPrefix("TaskDefinitionParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskDefinitionParameter = new QEntityPath(this.withPrefix("TaskDefinitionParameter"), () => QTaskDefinitionParameter);
}

export const qTaskDefinitionParameterFacet = new QTaskDefinitionParameterFacet();

export class QTaskDefinitionParameterFacetId extends QId<TaskDefinitionParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskDefinition_Id = new QGuidPath(this.withPrefix("TaskDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskDefinition = new QEntityPath(this.withPrefix("TaskDefinition"), () => QTaskDefinition);
}

export const qTaskDefinitionFacet = new QTaskDefinitionFacet();

export class QTaskDefinitionFacetId extends QId<TaskDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachine_Id = new QGuidPath(this.withPrefix("StateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StateMachine = new QEntityPath(this.withPrefix("StateMachine"), () => QStateMachine);
}

export const qStateMachineFacet = new QStateMachineFacet();

export class QStateMachineFacetId extends QId<StateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Status_Id = new QGuidPath(this.withPrefix("Status_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatus);
}

export const qStatusFacet = new QStatusFacet();

export class QStatusFacetId extends QId<StatusFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionError extends QueryObject {
    public readonly ErrorCode = new QNumberPath(this.withPrefix("ErrorCode"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
}

export const qExecutionError = new QExecutionError();

export class QPrecheckExecution extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FullName = new QStringPath(this.withPrefix("FullName"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
}

export const qPrecheckExecution = new QPrecheckExecution();

export class QSitUafExecutionDetail extends QueryObject {
    public readonly PrecheckDetails = new QEntityCollectionPath(this.withPrefix("PrecheckDetails"), () => QPrecheckExecution);
}

export const qSitUafExecutionDetail = new QSitUafExecutionDetail();

export class QCommandResponse extends QueryObject {
    public readonly Succeeded = new QBooleanPath(this.withPrefix("Succeeded"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
    public readonly SitUafExecutionDetail = new QEntityPath(this.withPrefix("SitUafExecutionDetail"), () => QSitUafExecutionDetail);
}

export const qCommandResponse = new QCommandResponse();

export class QFunctionResponse extends QCommandResponse {
}

export const qFunctionResponse = new QFunctionResponse();

export class QPreCheckResponse extends QCommandResponse {
}

export const qPreCheckResponse = new QPreCheckResponse();

export class QAdditionalArgumentsDefinition extends QueryObject {
}

export const qAdditionalArgumentsDefinition = new QAdditionalArgumentsDefinition();

export class QServiceLayerUnityError extends QueryObject {
    public readonly commandcallstack = new QCollectionPath(this.withPrefix("commandcallstack"), () => QStringCollection);
    public readonly stacktrace = new QStringPath(this.withPrefix("stacktrace"));
}

export const qServiceLayerUnityError = new QServiceLayerUnityError();

export class QServiceLayerErrorObject extends QueryObject {
    public readonly code = new QStringPath(this.withPrefix("code"));
    public readonly message = new QStringPath(this.withPrefix("message"));
    public readonly innererror = new QEntityPath(this.withPrefix("innererror"), () => QServiceLayerUnityError);
}

export const qServiceLayerErrorObject = new QServiceLayerErrorObject();

export class QServiceLayerError extends QueryObject {
    public readonly error = new QEntityPath(this.withPrefix("error"), () => QServiceLayerErrorObject);
}

export const qServiceLayerError = new QServiceLayerError();

export class QCreateTaskDefinitionResponse extends QCommandResponse {
    public readonly TaskDefinitionId = new QGuidPath(this.withPrefix("TaskDefinitionId"));
}

export const qCreateTaskDefinitionResponse = new QCreateTaskDefinitionResponse();

export class QCreateTaskDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qCreateTaskDefinition = new QCreateTaskDefinition();

export class QUpdateTaskDefinitionResponse extends QCommandResponse {
    public readonly ParameterIds = new QCollectionPath(this.withPrefix("ParameterIds"), () => QGuidCollection);
}

export const qUpdateTaskDefinitionResponse = new QUpdateTaskDefinitionResponse();

export class QUpdateTaskDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QTaskDefinitionParameterParameterType);
}

export const qUpdateTaskDefinition = new QUpdateTaskDefinition();

export class QDeleteTaskDefinitionResponse extends QCommandResponse {
}

export const qDeleteTaskDefinitionResponse = new QDeleteTaskDefinitionResponse();

export class QDeleteTaskDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTaskDefinition = new QDeleteTaskDefinition();

export class QUpdateTaskDefinitionParameterResponse extends QCommandResponse {
}

export const qUpdateTaskDefinitionParameterResponse = new QUpdateTaskDefinitionParameterResponse();

export class QUpdateTaskDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), TaskDefinitionParameterDirections);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qUpdateTaskDefinitionParameter = new QUpdateTaskDefinitionParameter();

export class QDeleteTaskDefinitionParameterResponse extends QCommandResponse {
}

export const qDeleteTaskDefinitionParameterResponse = new QDeleteTaskDefinitionParameterResponse();

export class QDeleteTaskDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTaskDefinitionParameter = new QDeleteTaskDefinitionParameter();

export class QLockTaskDefinitionResponse extends QCommandResponse {
}

export const qLockTaskDefinitionResponse = new QLockTaskDefinitionResponse();

export class QLockTaskDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qLockTaskDefinition = new QLockTaskDefinition();

export class QUnlockTaskDefinitionResponse extends QCommandResponse {
}

export const qUnlockTaskDefinitionResponse = new QUnlockTaskDefinitionResponse();

export class QUnlockTaskDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnlockTaskDefinition = new QUnlockTaskDefinition();

export class QSetTaskDefinitionRevisionCurrentResponse extends QCommandResponse {
}

export const qSetTaskDefinitionRevisionCurrentResponse = new QSetTaskDefinitionRevisionCurrentResponse();

export class QSetTaskDefinitionRevisionCurrent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSetTaskDefinitionRevisionCurrent = new QSetTaskDefinitionRevisionCurrent();

export class QUnsetTaskDefinitionRevisionCurrentResponse extends QCommandResponse {
}

export const qUnsetTaskDefinitionRevisionCurrentResponse = new QUnsetTaskDefinitionRevisionCurrentResponse();

export class QUnsetTaskDefinitionRevisionCurrent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnsetTaskDefinitionRevisionCurrent = new QUnsetTaskDefinitionRevisionCurrent();

export class QCopyTaskDefinitionRevisionResponse extends QCommandResponse {
    public readonly TaskDefinitionId = new QGuidPath(this.withPrefix("TaskDefinitionId"));
}

export const qCopyTaskDefinitionRevisionResponse = new QCopyTaskDefinitionRevisionResponse();

export class QCopyTaskDefinitionRevision extends QueryObject {
    public readonly SourceNId = new QStringPath(this.withPrefix("SourceNId"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly TargetNId = new QStringPath(this.withPrefix("TargetNId"));
    public readonly TargetRevision = new QStringPath(this.withPrefix("TargetRevision"));
}

export const qCopyTaskDefinitionRevision = new QCopyTaskDefinitionRevision();

export class QCreateNewTaskDefinitionRevisionResponse extends QCommandResponse {
    public readonly TaskDefinitionId = new QGuidPath(this.withPrefix("TaskDefinitionId"));
}

export const qCreateNewTaskDefinitionRevisionResponse = new QCreateNewTaskDefinitionRevisionResponse();

export class QCreateNewTaskDefinitionRevision extends QueryObject {
    public readonly SourceNId = new QStringPath(this.withPrefix("SourceNId"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly TargetRevision = new QStringPath(this.withPrefix("TargetRevision"));
}

export const qCreateNewTaskDefinitionRevision = new QCreateNewTaskDefinitionRevision();

export class QAssociateTaskContextDefinitionsWithTaskDefinitionResponse extends QCommandResponse {
}

export const qAssociateTaskContextDefinitionsWithTaskDefinitionResponse = new QAssociateTaskContextDefinitionsWithTaskDefinitionResponse();

export class QAssociateTaskContextDefinitionsWithTaskDefinition extends QueryObject {
    public readonly TaskDefinitionId = new QGuidPath(this.withPrefix("TaskDefinitionId"));
    public readonly TaskContextDefinitionIds = new QCollectionPath(this.withPrefix("TaskContextDefinitionIds"), () => QGuidCollection);
}

export const qAssociateTaskContextDefinitionsWithTaskDefinition = new QAssociateTaskContextDefinitionsWithTaskDefinition();

export class QDisassociateTaskContextDefinitionsFromTaskDefinitionResponse extends QCommandResponse {
}

export const qDisassociateTaskContextDefinitionsFromTaskDefinitionResponse = new QDisassociateTaskContextDefinitionsFromTaskDefinitionResponse();

export class QDisassociateTaskContextDefinitionsFromTaskDefinition extends QueryObject {
    public readonly TaskDefinitionId = new QGuidPath(this.withPrefix("TaskDefinitionId"));
    public readonly TaskContextDefinitionIds = new QCollectionPath(this.withPrefix("TaskContextDefinitionIds"), () => QGuidCollection);
}

export const qDisassociateTaskContextDefinitionsFromTaskDefinition = new QDisassociateTaskContextDefinitionsFromTaskDefinition();

export class QCreateTaskContextDefinitionResponse extends QCommandResponse {
    public readonly TaskContextDefinitionId = new QGuidPath(this.withPrefix("TaskContextDefinitionId"));
}

export const qCreateTaskContextDefinitionResponse = new QCreateTaskContextDefinitionResponse();

export class QCreateTaskContextDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateTaskContextDefinition = new QCreateTaskContextDefinition();

export class QUpdateTaskContextDefinitionResponse extends QCommandResponse {
    public readonly UserFieldIds = new QCollectionPath(this.withPrefix("UserFieldIds"), () => QGuidCollection);
}

export const qUpdateTaskContextDefinitionResponse = new QUpdateTaskContextDefinitionResponse();

export class QUpdateTaskContextDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QUserFieldParameterType);
}

export const qUpdateTaskContextDefinition = new QUpdateTaskContextDefinition();

export class QDeleteTaskContextDefinitionResponse extends QCommandResponse {
}

export const qDeleteTaskContextDefinitionResponse = new QDeleteTaskContextDefinitionResponse();

export class QDeleteTaskContextDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTaskContextDefinition = new QDeleteTaskContextDefinition();

export class QUpdateTaskContextDefinitionUserFieldResponse extends QCommandResponse {
}

export const qUpdateTaskContextDefinitionUserFieldResponse = new QUpdateTaskContextDefinitionUserFieldResponse();

export class QUpdateTaskContextDefinitionUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
}

export const qUpdateTaskContextDefinitionUserField = new QUpdateTaskContextDefinitionUserField();

export class QDeleteTaskContextDefinitionUserFieldResponse extends QCommandResponse {
}

export const qDeleteTaskContextDefinitionUserFieldResponse = new QDeleteTaskContextDefinitionUserFieldResponse();

export class QDeleteTaskContextDefinitionUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTaskContextDefinitionUserField = new QDeleteTaskContextDefinitionUserField();

export class QCreateTaskResponse extends QCommandResponse {
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
}

export const qCreateTaskResponse = new QCreateTaskResponse();

export class QCreateTask extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskDefinitionNId = new QStringPath(this.withPrefix("TaskDefinitionNId"));
    public readonly TaskDefinitionRevision = new QStringPath(this.withPrefix("TaskDefinitionRevision"));
    public readonly IsSkippable = new QBooleanPath(this.withPrefix("IsSkippable"));
    public readonly TaskFlow = new QEntityPath(this.withPrefix("TaskFlow"), () => QTaskFlowParameterType);
    public readonly ParameterValues = new QEntityCollectionPath(this.withPrefix("ParameterValues"), () => QParameterValueParameterType);
    public readonly ContextUserFieldValues = new QEntityCollectionPath(this.withPrefix("ContextUserFieldValues"), () => QContainerUserFieldParameterType);
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qCreateTask = new QCreateTask();

export class QUpdateTaskResponse extends QCommandResponse {
    public readonly ParameterIds = new QCollectionPath(this.withPrefix("ParameterIds"), () => QGuidCollection);
}

export const qUpdateTaskResponse = new QUpdateTaskResponse();

export class QUpdateTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ErrorCount = new QNumberPath(this.withPrefix("ErrorCount"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly TaskFlow = new QEntityPath(this.withPrefix("TaskFlow"), () => QTaskFlowParameterType);
    public readonly IsSkippable = new QBooleanPath(this.withPrefix("IsSkippable"));
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QTaskDefinitionParameterParameterType);
    public readonly ParameterValues = new QEntityCollectionPath(this.withPrefix("ParameterValues"), () => QParameterValueParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUpdateTask = new QUpdateTask();

export class QDeleteTaskResponse extends QCommandResponse {
}

export const qDeleteTaskResponse = new QDeleteTaskResponse();

export class QDeleteTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTask = new QDeleteTask();

export class QUpdateTaskParameterResponse extends QCommandResponse {
}

export const qUpdateTaskParameterResponse = new QUpdateTaskParameterResponse();

export class QUpdateTaskParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qUpdateTaskParameter = new QUpdateTaskParameter();

export class QSetTaskStatusResponse extends QCommandResponse {
}

export const qSetTaskStatusResponse = new QSetTaskStatusResponse();

export class QSetTaskStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qSetTaskStatus = new QSetTaskStatus();

export class QForceTaskStatusResponse extends QCommandResponse {
}

export const qForceTaskStatusResponse = new QForceTaskStatusResponse();

export class QForceTaskStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly UserName = new QStringPath(this.withPrefix("UserName"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qForceTaskStatus = new QForceTaskStatus();

export class QActivateTaskResponse extends QCommandResponse {
}

export const qActivateTaskResponse = new QActivateTaskResponse();

export class QActivateTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qActivateTask = new QActivateTask();

export class QSuspendTaskResponse extends QCommandResponse {
}

export const qSuspendTaskResponse = new QSuspendTaskResponse();

export class QSuspendTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qSuspendTask = new QSuspendTask();

export class QStartTaskResponse extends QCommandResponse {
}

export const qStartTaskResponse = new QStartTaskResponse();

export class QStartTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qStartTask = new QStartTask();

export class QPauseTaskResponse extends QCommandResponse {
}

export const qPauseTaskResponse = new QPauseTaskResponse();

export class QPauseTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qPauseTask = new QPauseTask();

export class QResumeTaskResponse extends QCommandResponse {
}

export const qResumeTaskResponse = new QResumeTaskResponse();

export class QResumeTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qResumeTask = new QResumeTask();

export class QRecoverTaskResponse extends QCommandResponse {
}

export const qRecoverTaskResponse = new QRecoverTaskResponse();

export class QRecoverTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qRecoverTask = new QRecoverTask();

export class QFailTaskResponse extends QCommandResponse {
}

export const qFailTaskResponse = new QFailTaskResponse();

export class QFailTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qFailTask = new QFailTask();

export class QCompleteTaskResponse extends QCommandResponse {
}

export const qCompleteTaskResponse = new QCompleteTaskResponse();

export class QCompleteTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qCompleteTask = new QCompleteTask();

export class QAbortTaskResponse extends QCommandResponse {
}

export const qAbortTaskResponse = new QAbortTaskResponse();

export class QAbortTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qAbortTask = new QAbortTask();

export class QCancelTaskResponse extends QCommandResponse {
}

export const qCancelTaskResponse = new QCancelTaskResponse();

export class QCancelTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qCancelTask = new QCancelTask();

export class QSkipTaskResponse extends QCommandResponse {
}

export const qSkipTaskResponse = new QSkipTaskResponse();

export class QSkipTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qSkipTask = new QSkipTask();

export class QFreezeTaskResponse extends QCommandResponse {
}

export const qFreezeTaskResponse = new QFreezeTaskResponse();

export class QFreezeTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qFreezeTask = new QFreezeTask();

export class QUnfreezeTaskResponse extends QCommandResponse {
}

export const qUnfreezeTaskResponse = new QUnfreezeTaskResponse();

export class QUnfreezeTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnfreezeTask = new QUnfreezeTask();

export class QSetErrorCountResponse extends QCommandResponse {
}

export const qSetErrorCountResponse = new QSetErrorCountResponse();

export class QSetErrorCount extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ErrorCount = new QNumberPath(this.withPrefix("ErrorCount"));
}

export const qSetErrorCount = new QSetErrorCount();

export class QChangeTaskStatusOnActionResponse extends QCommandResponse {
}

export const qChangeTaskStatusOnActionResponse = new QChangeTaskStatusOnActionResponse();

export class QChangeTaskStatusOnAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qChangeTaskStatusOnAction = new QChangeTaskStatusOnAction();

export class QRepeatTaskResponse extends QCommandResponse {
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
}

export const qRepeatTaskResponse = new QRepeatTaskResponse();

export class QRepeatTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qRepeatTask = new QRepeatTask();

export class QActivateSequenceStepResponse extends QCommandResponse {
}

export const qActivateSequenceStepResponse = new QActivateSequenceStepResponse();

export class QActivateSequenceStep extends QueryObject {
    public readonly TaskFlow = new QStringPath(this.withPrefix("TaskFlow"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qActivateSequenceStep = new QActivateSequenceStep();

export class QCheckSequenceStepCompletedResponse extends QCommandResponse {
}

export const qCheckSequenceStepCompletedResponse = new QCheckSequenceStepCompletedResponse();

export class QCheckSequenceStepCompleted extends QueryObject {
    public readonly SectionToken = new QStringPath(this.withPrefix("SectionToken"));
    public readonly Block = new QBooleanPath(this.withPrefix("Block"));
    public readonly SiblingCount = new QNumberPath(this.withPrefix("SiblingCount"));
    public readonly TaskFlow = new QStringPath(this.withPrefix("TaskFlow"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly BlockAndContinue = new QBooleanPath(this.withPrefix("BlockAndContinue"));
    public readonly IsLastStep = new QBooleanPath(this.withPrefix("IsLastStep"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qCheckSequenceStepCompleted = new QCheckSequenceStepCompleted();

export class QRemoveTaskFromTaskFlowResponse extends QCommandResponse {
}

export const qRemoveTaskFromTaskFlowResponse = new QRemoveTaskFromTaskFlowResponse();

export class QRemoveTaskFromTaskFlow extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qRemoveTaskFromTaskFlow = new QRemoveTaskFromTaskFlow();

export class QTaskDefinitionParameterParameterType extends QueryObject {
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), TaskDefinitionParameterDirections);
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qTaskDefinitionParameterParameterType = new QTaskDefinitionParameterParameterType();

export class QUserFieldParameterType extends QueryObject {
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qUserFieldParameterType = new QUserFieldParameterType();

export class QParameterValueParameterType extends QueryObject {
    public readonly ParameterNId = new QStringPath(this.withPrefix("ParameterNId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qParameterValueParameterType = new QParameterValueParameterType();

export class QUserFieldValueParameterType extends QueryObject {
    public readonly UserFieldNId = new QStringPath(this.withPrefix("UserFieldNId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
}

export const qUserFieldValueParameterType = new QUserFieldValueParameterType();

export class QContainerUserFieldParameterType extends QueryObject {
    public readonly ContainerDefinitionNId = new QStringPath(this.withPrefix("ContainerDefinitionNId"));
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly UserFieldValues = new QEntityCollectionPath(this.withPrefix("UserFieldValues"), () => QUserFieldValueParameterType);
}

export const qContainerUserFieldParameterType = new QContainerUserFieldParameterType();

export class QStatusTypeParameterType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
}

export const qStatusTypeParameterType = new QStatusTypeParameterType();

export class QTaskFlowParameterType extends QueryObject {
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly MaxIterations = new QNumberPath(this.withPrefix("MaxIterations"));
    public readonly TaskFlow = new QStringPath(this.withPrefix("TaskFlow"));
    public readonly ContinueOnSuccess = new QBooleanPath(this.withPrefix("ContinueOnSuccess"));
    public readonly ContinueOnFailure = new QBooleanPath(this.withPrefix("ContinueOnFailure"));
}

export const qTaskFlowParameterType = new QTaskFlowParameterType();

export class QDeleteTasksResponse extends QCommandResponse {
    public readonly DeletedTaskIds = new QCollectionPath(this.withPrefix("DeletedTaskIds"), () => QGuidCollection);
    public readonly NotDeletedTaskIds = new QCollectionPath(this.withPrefix("NotDeletedTaskIds"), () => QGuidCollection);
}

export const qDeleteTasksResponse = new QDeleteTasksResponse();

export class QDeleteTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteTasks = new QDeleteTasks();

export class QActivateTasksResponse extends QCommandResponse {
    public readonly ActivatedTaskIds = new QCollectionPath(this.withPrefix("ActivatedTaskIds"), () => QGuidCollection);
    public readonly NotActivatedTaskIds = new QCollectionPath(this.withPrefix("NotActivatedTaskIds"), () => QGuidCollection);
}

export const qActivateTasksResponse = new QActivateTasksResponse();

export class QActivateTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qActivateTasks = new QActivateTasks();

export class QAbortTasksResponse extends QCommandResponse {
    public readonly AbortedTaskIds = new QCollectionPath(this.withPrefix("AbortedTaskIds"), () => QGuidCollection);
    public readonly NotAbortedTaskIds = new QCollectionPath(this.withPrefix("NotAbortedTaskIds"), () => QGuidCollection);
}

export const qAbortTasksResponse = new QAbortTasksResponse();

export class QAbortTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qAbortTasks = new QAbortTasks();

export class QCancelTasksResponse extends QCommandResponse {
    public readonly CanceledTaskIds = new QCollectionPath(this.withPrefix("CanceledTaskIds"), () => QGuidCollection);
    public readonly NotCanceledTaskIds = new QCollectionPath(this.withPrefix("NotCanceledTaskIds"), () => QGuidCollection);
}

export const qCancelTasksResponse = new QCancelTasksResponse();

export class QCancelTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qCancelTasks = new QCancelTasks();

export class QCompleteTasksResponse extends QCommandResponse {
    public readonly CompletedTaskIds = new QCollectionPath(this.withPrefix("CompletedTaskIds"), () => QGuidCollection);
    public readonly NotCompletedTaskIds = new QCollectionPath(this.withPrefix("NotCompletedTaskIds"), () => QGuidCollection);
}

export const qCompleteTasksResponse = new QCompleteTasksResponse();

export class QCompleteTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qCompleteTasks = new QCompleteTasks();

export class QSkipTasksResponse extends QCommandResponse {
    public readonly SkippedTaskIds = new QCollectionPath(this.withPrefix("SkippedTaskIds"), () => QGuidCollection);
    public readonly NotSkippedTaskIds = new QCollectionPath(this.withPrefix("NotSkippedTaskIds"), () => QGuidCollection);
}

export const qSkipTasksResponse = new QSkipTasksResponse();

export class QSkipTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qSkipTasks = new QSkipTasks();

export class QSuspendTasksResponse extends QCommandResponse {
    public readonly SuspendedTaskIds = new QCollectionPath(this.withPrefix("SuspendedTaskIds"), () => QGuidCollection);
    public readonly NotSuspendedTaskIds = new QCollectionPath(this.withPrefix("NotSuspendedTaskIds"), () => QGuidCollection);
}

export const qSuspendTasksResponse = new QSuspendTasksResponse();

export class QSuspendTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qSuspendTasks = new QSuspendTasks();

export class QPauseTasksResponse extends QCommandResponse {
    public readonly PausedTaskIds = new QCollectionPath(this.withPrefix("PausedTaskIds"), () => QGuidCollection);
    public readonly NotPausedTaskIds = new QCollectionPath(this.withPrefix("NotPausedTaskIds"), () => QGuidCollection);
}

export const qPauseTasksResponse = new QPauseTasksResponse();

export class QPauseTasks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qPauseTasks = new QPauseTasks();

export class QDeleteTaskDefinitionsResponse extends QCommandResponse {
    public readonly DeletedTaskDefinitionIds = new QCollectionPath(this.withPrefix("DeletedTaskDefinitionIds"), () => QGuidCollection);
    public readonly NotDeletedTaskDefinitionIds = new QCollectionPath(this.withPrefix("NotDeletedTaskDefinitionIds"), () => QGuidCollection);
}

export const qDeleteTaskDefinitionsResponse = new QDeleteTaskDefinitionsResponse();

export class QDeleteTaskDefinitions extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteTaskDefinitions = new QDeleteTaskDefinitions();

export class QDeleteTaskContextDefinitionsResponse extends QCommandResponse {
    public readonly DeletedTaskContextDefinitionIds = new QCollectionPath(this.withPrefix("DeletedTaskContextDefinitionIds"), () => QGuidCollection);
    public readonly NotDeletedTaskContextDefinitionIds = new QCollectionPath(this.withPrefix("NotDeletedTaskContextDefinitionIds"), () => QGuidCollection);
}

export const qDeleteTaskContextDefinitionsResponse = new QDeleteTaskContextDefinitionsResponse();

export class QDeleteTaskContextDefinitions extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteTaskContextDefinitions = new QDeleteTaskContextDefinitions();

export class QGetTasksForTaskListResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskMessageUI = new QStringPath(this.withPrefix("TaskMessageUI"));
    public readonly TaskDefinitionNId = new QStringPath(this.withPrefix("TaskDefinitionNId"));
    public readonly TaskDefinitionRevision = new QStringPath(this.withPrefix("TaskDefinitionRevision"));
    public readonly ErrorCount = new QNumberPath(this.withPrefix("ErrorCount"));
    public readonly IsSkippable = new QBooleanPath(this.withPrefix("IsSkippable"));
    public readonly TaskInstanceUI = new QStringPath(this.withPrefix("TaskInstanceUI"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusTypeParameterType);
    public readonly TaskFlow = new QEntityPath(this.withPrefix("TaskFlow"), () => QTaskFlowParameterType);
    public readonly IsRepeatable = new QBooleanPath(this.withPrefix("IsRepeatable"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qGetTasksForTaskListResponse = new QGetTasksForTaskListResponse();

export class QGetTasksForTaskList extends QueryObject {
    public readonly HideTasksInFinalStates = new QBooleanPath(this.withPrefix("HideTasksInFinalStates"));
    public readonly TaskContextUserFieldValues = new QEntityCollectionPath(this.withPrefix("TaskContextUserFieldValues"), () => QContainerUserFieldParameterType);
}

export const qGetTasksForTaskList = new QGetTasksForTaskList();

export class QGetAllTasksResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskDefinitionNId = new QStringPath(this.withPrefix("TaskDefinitionNId"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStateMachineStatusNIdParameterType);
    public readonly Contexts = new QEntityCollectionPath(this.withPrefix("Contexts"), () => QTaskContextParameterType);
}

export const qGetAllTasksResponse = new QGetAllTasksResponse();

export class QGetAllTasks extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
    public readonly TaskContextUserFieldValues = new QEntityCollectionPath(this.withPrefix("TaskContextUserFieldValues"), () => QUserFieldValueParameterType);
}

export const qGetAllTasks = new QGetAllTasks();

export class QIQueryable extends QueryObject {
}

export const qIQueryable = new QIQueryable();

export class QStateMachineStatusNIdParameterType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qStateMachineStatusNIdParameterType = new QStateMachineStatusNIdParameterType();

export class QTaskContextParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QUserFieldValueParameterType);
}

export const qTaskContextParameterType = new QTaskContextParameterType();

export class QBaseResponse extends QCommandResponse {
}

export const qBaseResponse = new QBaseResponse();

export class QTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types extends QueryObject {
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly MaxIterations = new QNumberPath(this.withPrefix("MaxIterations"));
    public readonly IterationGroupId = new QGuidPath(this.withPrefix("IterationGroupId"));
    public readonly ContinueOnSuccess = new QBooleanPath(this.withPrefix("ContinueOnSuccess"));
    public readonly ContinueOnFailure = new QBooleanPath(this.withPrefix("ContinueOnFailure"));
    public readonly TaskFlow = new QStringPath(this.withPrefix("TaskFlow"));
}

export const qTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types = new QTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types();

export class QQuantityType extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly QuantityValue = new QNumberPath(this.withPrefix("QuantityValue"));
}

export const qQuantityType = new QQuantityType();

export class QStatusType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qStatusType = new QStatusType();

export class QGetTasksForTaskList2 extends QFunction<GetTasksForTaskList2Params> {
    private readonly params = [new QComplexParam("function", new QGetTasksForTaskList())];

    constructor() {
        super("GetTasksForTaskList", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QGetAllTasks2 extends QFunction<GetAllTasks2Params> {
    private readonly params = [new QComplexParam("function", new QGetAllTasks())];

    constructor() {
        super("GetAllTasks", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTaskDefinition2 extends QAction<CreateTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CreateTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTaskDefinition2 extends QAction<UpdateTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UpdateTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTaskDefinition2 extends QAction<DeleteTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTaskDefinitionParameter2 extends QAction<UpdateTaskDefinitionParameter2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTaskDefinitionParameter()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UpdateTaskDefinitionParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTaskDefinitionParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTaskDefinitionParameter2 extends QAction<DeleteTaskDefinitionParameter2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTaskDefinitionParameter()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTaskDefinitionParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskDefinitionParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLockTaskDefinition2 extends QAction<LockTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QLockTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("LockTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLockTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlockTaskDefinition2 extends QAction<UnlockTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUnlockTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UnlockTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlockTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetTaskDefinitionRevisionCurrent2 extends QAction<SetTaskDefinitionRevisionCurrent2Params> {
    private readonly params = [new QComplexParam("command", new QSetTaskDefinitionRevisionCurrent()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SetTaskDefinitionRevisionCurrent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetTaskDefinitionRevisionCurrentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnsetTaskDefinitionRevisionCurrent2 extends QAction<UnsetTaskDefinitionRevisionCurrent2Params> {
    private readonly params = [new QComplexParam("command", new QUnsetTaskDefinitionRevisionCurrent()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UnsetTaskDefinitionRevisionCurrent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnsetTaskDefinitionRevisionCurrentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyTaskDefinitionRevision2 extends QAction<CopyTaskDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCopyTaskDefinitionRevision()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CopyTaskDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyTaskDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewTaskDefinitionRevision2 extends QAction<CreateNewTaskDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewTaskDefinitionRevision()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CreateNewTaskDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewTaskDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateTaskContextDefinitionsWithTaskDefinition2 extends QAction<AssociateTaskContextDefinitionsWithTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateTaskContextDefinitionsWithTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("AssociateTaskContextDefinitionsWithTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateTaskContextDefinitionsWithTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassociateTaskContextDefinitionsFromTaskDefinition2 extends QAction<DisassociateTaskContextDefinitionsFromTaskDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDisassociateTaskContextDefinitionsFromTaskDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DisassociateTaskContextDefinitionsFromTaskDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassociateTaskContextDefinitionsFromTaskDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTaskContextDefinition2 extends QAction<CreateTaskContextDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTaskContextDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CreateTaskContextDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTaskContextDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTaskContextDefinition2 extends QAction<UpdateTaskContextDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTaskContextDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UpdateTaskContextDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTaskContextDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTaskContextDefinition2 extends QAction<DeleteTaskContextDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTaskContextDefinition()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTaskContextDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskContextDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTaskContextDefinitionUserField2 extends QAction<UpdateTaskContextDefinitionUserField2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTaskContextDefinitionUserField()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UpdateTaskContextDefinitionUserField", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTaskContextDefinitionUserFieldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTaskContextDefinitionUserField2 extends QAction<DeleteTaskContextDefinitionUserField2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTaskContextDefinitionUserField()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTaskContextDefinitionUserField", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskContextDefinitionUserFieldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTask2 extends QAction<CreateTask2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CreateTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTask2 extends QAction<UpdateTask2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UpdateTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTask2 extends QAction<DeleteTask2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTaskParameter2 extends QAction<UpdateTaskParameter2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTaskParameter()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UpdateTaskParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTaskParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetTaskStatus2 extends QAction<SetTaskStatus2Params> {
    private readonly params = [new QComplexParam("command", new QSetTaskStatus()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SetTaskStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetTaskStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QForceTaskStatus2 extends QAction<ForceTaskStatus2Params> {
    private readonly params = [new QComplexParam("command", new QForceTaskStatus()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("ForceTaskStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QForceTaskStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QActivateTask2 extends QAction<ActivateTask2Params> {
    private readonly params = [new QComplexParam("command", new QActivateTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("ActivateTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QActivateTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSuspendTask2 extends QAction<SuspendTask2Params> {
    private readonly params = [new QComplexParam("command", new QSuspendTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SuspendTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSuspendTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartTask2 extends QAction<StartTask2Params> {
    private readonly params = [new QComplexParam("command", new QStartTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("StartTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPauseTask2 extends QAction<PauseTask2Params> {
    private readonly params = [new QComplexParam("command", new QPauseTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("PauseTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPauseTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QResumeTask2 extends QAction<ResumeTask2Params> {
    private readonly params = [new QComplexParam("command", new QResumeTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("ResumeTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QResumeTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRecoverTask2 extends QAction<RecoverTask2Params> {
    private readonly params = [new QComplexParam("command", new QRecoverTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("RecoverTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRecoverTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFailTask2 extends QAction<FailTask2Params> {
    private readonly params = [new QComplexParam("command", new QFailTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("FailTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFailTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteTask2 extends QAction<CompleteTask2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CompleteTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAbortTask2 extends QAction<AbortTask2Params> {
    private readonly params = [new QComplexParam("command", new QAbortTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("AbortTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAbortTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCancelTask2 extends QAction<CancelTask2Params> {
    private readonly params = [new QComplexParam("command", new QCancelTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CancelTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCancelTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSkipTask2 extends QAction<SkipTask2Params> {
    private readonly params = [new QComplexParam("command", new QSkipTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SkipTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSkipTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFreezeTask2 extends QAction<FreezeTask2Params> {
    private readonly params = [new QComplexParam("command", new QFreezeTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("FreezeTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFreezeTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnfreezeTask2 extends QAction<UnfreezeTask2Params> {
    private readonly params = [new QComplexParam("command", new QUnfreezeTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("UnfreezeTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnfreezeTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetErrorCount2 extends QAction<SetErrorCount2Params> {
    private readonly params = [new QComplexParam("command", new QSetErrorCount()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SetErrorCount", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetErrorCountResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeTaskStatusOnAction2 extends QAction<ChangeTaskStatusOnAction2Params> {
    private readonly params = [new QComplexParam("command", new QChangeTaskStatusOnAction()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("ChangeTaskStatusOnAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeTaskStatusOnActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRepeatTask2 extends QAction<RepeatTask2Params> {
    private readonly params = [new QComplexParam("command", new QRepeatTask()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("RepeatTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRepeatTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QActivateSequenceStep2 extends QAction<ActivateSequenceStep2Params> {
    private readonly params = [new QComplexParam("command", new QActivateSequenceStep()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("ActivateSequenceStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QActivateSequenceStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckSequenceStepCompleted2 extends QAction<CheckSequenceStepCompleted2Params> {
    private readonly params = [new QComplexParam("command", new QCheckSequenceStepCompleted()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CheckSequenceStepCompleted", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckSequenceStepCompletedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveTaskFromTaskFlow2 extends QAction<RemoveTaskFromTaskFlow2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveTaskFromTaskFlow()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("RemoveTaskFromTaskFlow", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveTaskFromTaskFlowResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTasks2 extends QAction<DeleteTasks2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QActivateTasks2 extends QAction<ActivateTasks2Params> {
    private readonly params = [new QComplexParam("command", new QActivateTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("ActivateTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QActivateTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAbortTasks2 extends QAction<AbortTasks2Params> {
    private readonly params = [new QComplexParam("command", new QAbortTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("AbortTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAbortTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCancelTasks2 extends QAction<CancelTasks2Params> {
    private readonly params = [new QComplexParam("command", new QCancelTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CancelTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCancelTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteTasks2 extends QAction<CompleteTasks2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("CompleteTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSkipTasks2 extends QAction<SkipTasks2Params> {
    private readonly params = [new QComplexParam("command", new QSkipTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SkipTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSkipTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSuspendTasks2 extends QAction<SuspendTasks2Params> {
    private readonly params = [new QComplexParam("command", new QSuspendTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("SuspendTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSuspendTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPauseTasks2 extends QAction<PauseTasks2Params> {
    private readonly params = [new QComplexParam("command", new QPauseTasks()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("PauseTasks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPauseTasksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTaskDefinitions2 extends QAction<DeleteTaskDefinitions2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTaskDefinitions()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTaskDefinitions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskDefinitionsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTaskContextDefinitions2 extends QAction<DeleteTaskContextDefinitions2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTaskContextDefinitions()),new QComplexParam("additional", new QAdditionalArgumentsDefinition())];

    constructor() {
        super("DeleteTaskContextDefinitions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTaskContextDefinitionsResponse)))
    }

    getParams() {
        return this.params
    }
}
